import { useIsMobile } from '@yes.technology/react-toolkit'
import Tabs from 'component/Tabs'
import { TabItem } from 'component/Tabs/Tabs.types'
import { forwardRef, useImperativeHandle } from 'react'
import { TabsContainer } from '../FilteredObjects/styles'

export type TabsRefProps = { getTabs: () => TabItem[] }

export type MapContentTabsProps = {
  tabs: TabItem[]
  onItemSelect: (tab: TabItem) => void
  selectedItem: TabItem
  highlightColor?: string
}

const MapContentTabs = forwardRef<
  TabsRefProps,
  React.PropsWithChildren<MapContentTabsProps>
>(({ tabs, selectedItem, onItemSelect, highlightColor }, ref) => {
  const isMobile = useIsMobile()

  useImperativeHandle(
    ref,
    () => ({
      getTabs: () => tabs
    }),
    [tabs]
  )

  const tabsHeightClass = isMobile ? 'medium' : 'large'

  return (
    <TabsContainer $tabsCount={tabs.length}>
      <Tabs
        heightClass={tabsHeightClass}
        onItemSelect={onItemSelect}
        selectedItem={selectedItem}
        items={tabs}
        highlightColor={highlightColor}
      />
    </TabsContainer>
  )
})

MapContentTabs.displayName = 'MapContentTabs'

export default MapContentTabs
